import { render } from "./error-page.vue?vue&type=template&id=73437f66"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__